<div class="flex flex-column layout">
  <app-client-header/>

  @if (sidebarService.isMobile()) {
    <p-drawer [(visible)]="sidebarService.isDrawerVisible" position="left" [modal]="true" [dismissible]="true" [closeOnEscape]="true" [closable]="false" [blockScroll]="true"
             [pt]="{ header: { style: 'display: none' }, content: { style: 'padding: 0; overflow: hidden' }, root: { style: 'background: #F0F2F5' } }">
      <app-client-menu-drawer/>
    </p-drawer>
  }

  <div class="flex-1 content">
    @if (fullWidth()) {
      <router-outlet></router-outlet>
    } @else {
      <div class="content-inner">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
